<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span v-if="isUpdateForm">{{ $t('detection_set.update_title') }}</span>
            <span v-else>{{ $t('detection_set.create_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary" />
      </div>
      <div v-else>
        <b-form-group :invalid-feedback="fErr('name')">
          <label>{{ $t('detection_set.name') }}</label>
          <b-form-input type="text" :placeholder="$t('detection_set.name_placeholder')"
            :class="{ 'is-invalid': fErr('name') }" v-model="entity.name" />
        </b-form-group>
        <b-form-group :invalid-feedback="fErr('json_schema')">
          <label>{{ $t('detection_set.json_schema') }}</label>
          <b-form-select v-model="entity.json_schema_id" :options="json_schemas"></b-form-select>
        </b-form-group>
         <b-form-group :invalid-feedback="fErr('storage_type')">
          <label>{{ $t('detection_set.storage_type') }}</label>
          <b-form-select v-model="entity.storage_type" :options="['internal', 'external']"></b-form-select>
        </b-form-group>
        <b-form-group :invalid-feedback="fErr('s3_env_prefix')" v-if="entity.storage_type == 'external'">
          <label>{{ $t('detection_set.s3_env_prefix') }}</label>
          <b-form-input type="text"
            :class="{ 'is-invalid': fErr('s3_env_prefix') }" v-model="entity.s3_env_prefix" />
        </b-form-group>
      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small />
          {{ $t('global.save') }}
        </b-button>
        <router-view :to="{ name: 'DetectionSets' }">
          <b-button type="reset" variant="info" class="ml-2">
            {{ $t('global.cancel') }}
          </b-button>
        </router-view>
      </div>
    </b-card>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import { mapState } from 'vuex';
import Services from '@/services/index';

export default {
  mounted() {
    this.loadEntity();
    this.loadJsonSchemas();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: false,
        isSaving: false,
      },
      entity: this.value,
      errorMsg: this.errors,
      json_schemas: [],
    };
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: Number, default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          name: '',
        };
      },
    },
  },
  components: {
  },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
    isUpdateForm() { return this.id !== null; },
    ...mapState('Auth', ['activeProjectId']),
    projectId() { return this.project_id || this.activeProjectId; },
  },
  methods: {
    getForUpdate: Services.detectionSets.editData,
    getForCreate: Services.detectionSets.createData,
    pushUpdate: Services.detectionSets.update,
    pushCreate: Services.detectionSets.create,
    loadEntity() {
      this.spinners.contentIsLoading = true;
      const action = this.isUpdateForm ? this.getForUpdate : this.getForCreate;
      action(this.projectId, this.$route.params.id).then((data) => {
        this.spinners.contentIsLoading = false;
        this.entity = this.isUpdateForm ? data.data.detectionSet : { ...this.entity, ...data.data.detectionSet };
      }).catch((data) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = data.data ? data.data.errors : {};
      });
    },
    loadJsonSchemas() {
      Services.jsonSchemas.list(this.projectId).then((response) => {
        this.json_schemas = response.data.data.map((item) => ({ text: item.name, value: item.id }));
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      const action = this.isUpdateForm ? this.pushUpdate : this.pushCreate;
      action(this.projectId, { ...this.entity, project_id: this.projectId }).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        // this.entity = data.data; // This wont work if entity has nested objects/forms
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
        if (!this.isUpdateForm) {
          // After successful create
          // if (this.$can('edit', 'detection_sets')) {
          this.$router.push({ name: 'DetectionSetUpdate', params: { id: data.data.id } });
          // } else { // do not redirect if cannot edit
          //   this.entity = this.$options.props.value.default();
          //   this.load();
          // }
        }
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },
  }
};
</script>

<style scoped></style>
